import { Builder } from '@builder.io/react'
import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'

import './index.css'

interface Testimonial {
  backgroundColor: string
  textColor: string
  imgSrc: any
  testimonialText: string
  author: string
  designation: string
  altImage: string
}

interface Props {
  backgroundColor: string
  enableQuote: boolean
  testimonials: Testimonial[]
  quoteColor: string
  autoplayTime: number
}

const TestimonialTwo = ({ backgroundColor, enableQuote, testimonials, autoplayTime, quoteColor }: Props) => {
  const [carouselSettings, setCarouselSettings] = useState({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: autoplayTime
  })

  useEffect(() => {
    setCarouselSettings({
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: autoplayTime
    })
  }, [autoplayTime, backgroundColor])

  const getQuote = () => {
    if (!enableQuote) return null
    return (
      <svg
        width={24}
        height={18}
        viewBox="0 0 24 18"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="flex-shrink-0 text-gray-300 sm:ml-4"
        style={{ color: quoteColor }}
      >
        <path
          d="M0 18h8.7v-5.555c-.024-3.906 1.113-6.841 2.892-9.68L6.452 0C3.188 2.644-.026 7.86 0 12.469V18zm12.408 0h8.7v-5.555C21.083 8.539 22.22 5.604 24 2.765L18.859 0c-3.263 2.644-6.476 7.86-6.451 12.469V18z"
          fill="currentColor"
        />
      </svg>
    )
  }

  const pageCount: number = Math.ceil(testimonials.length / 3)

  console.log('Page Count here', pageCount)

  const getTestimonials = (tracker: number) => {
    const blockTestimonials: any[] = []
    // console.log('tracker value', tracker);
    for (let k = tracker - 3; k < tracker; k++) {
      console.log('k value for each iteration', k)
      const testimonial = testimonials[k]
      if (testimonial) {
        blockTestimonials.push(
          <blockquote
            key={`${testimonial.author}-${k}`}
            className="blockquote-wrapper rounded-lg p-3 sm:block lg:grid"
            style={{ backgroundColor: testimonial.backgroundColor }}
          >
            <div
              className="aspect-w-10 aspect-h-6 mb-5 max-h-48 overflow-hidden rounded-xl sm:aspect-w-16 sm:aspect-h-7 lg:aspect-none"
              style={{ width: '100%' }}
            >
              <img
                className="object-cover lg:w-full"
                src={
                  testimonial.imgSrc ||
                  'https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2102&q=80'
                }
                alt={testimonial.altImage}
              />
            </div>
            <div className="blockquote-quote-container sm:ml-6 lg:ml-0">
              <p className="text-lg text-gray-600" style={{ color: testimonial.textColor }}>
                {getQuote()}
                <br />
                {testimonial.testimonialText}
              </p>
              <cite
                className="mt-4 block font-semibold not-italic text-gray-900"
                style={{ color: testimonial.textColor }}
              >
                {testimonial.author && testimonial.designation
                  ? `${testimonial.author}, ${testimonial.designation}`
                  : `${testimonial.author} ${testimonial.designation}`}
              </cite>
            </div>
          </blockquote>
        )
      }
    }

    return blockTestimonials
  }

  const getTestimonialBlocks = () => {
    const blockArr: any[] = []
    for (let i = 0; i < pageCount; i++) {
      const testimonialTracker = (i + 1) * 3
      blockArr.push(
        <div
          className="slick-carousel-avoid-inline-block space-y-16 lg:grid lg:grid-cols-3 lg:gap-x-8 lg:space-y-0"
          key={i}
        >
          {getTestimonials(testimonialTracker)}
        </div>
      )
    }

    return blockArr
  }

  return (
    <div className="relative overflow-hidden bg-white" style={{ backgroundColor: backgroundColor }}>
      {/* Testimonials */}
      <section
        aria-labelledby="testimonial-heading"
        className="relative mx-auto max-w-7xl py-5 px-4 sm:px-6 lg:py-10 lg:px-8"
      >
        <div className="mx-auto max-w-2xl lg:max-w-none">
          <Slider {...carouselSettings}>{getTestimonialBlocks()}</Slider>
        </div>
      </section>
    </div>
  )
}

export default TestimonialTwo

Builder.registerComponent(TestimonialTwo, {
  name: 'TestimonialTwo',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'enableQuote',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'quoteColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'autoplayTime',
      type: 'number',
      defaultValue: 3000
    },
    {
      name: 'testimonials',
      type: 'list',
      defaultValue: [
        {
          backgroundColor: '#424dd7',
          textColor: 'white',
          imgSrc: null,
          testimonialText:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed urna nulla vitae laoreet augue.',
          author: 'Judith Bekker',
          designation: 'CEO at Something',
          altText: ''
        }
      ],
      subFields: [
        { name: 'backgroundColor', type: 'color', defaultValue: '#424dd7' },
        { name: 'textColor', type: 'color', defaultValue: 'white' },
        { name: 'imgSrc', type: 'file', defaultValue: null },
        {
          name: 'testimonialText',
          type: 'string',
          defaultValue: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed urna nulla vitae laoreet augue.'
        },
        { name: 'author', type: 'string', defaultValue: 'Judith Bekker' },
        { name: 'designation', type: 'string', defaultValue: 'CEO at Something' },
        { name: 'altText', type: 'text', defaultValue: '' }
      ]
    }
  ]
})
